import { render, staticRenderFns } from "./newCustomer.vue?vue&type=template&id=79e01e61&scoped=true"
import script from "./newCustomer.vue?vue&type=script&lang=js"
export * from "./newCustomer.vue?vue&type=script&lang=js"
import style0 from "./newCustomer.vue?vue&type=style&index=0&id=79e01e61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e01e61",
  null
  
)

export default component.exports